import { render, staticRenderFns } from "./EditPolicyModal.vue?vue&type=template&id=5a4f0170&scoped=true"
import script from "./EditPolicyModal.vue?vue&type=script&lang=ts"
export * from "./EditPolicyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f0170",
  null
  
)

export default component.exports